"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIListingPage = _interopRequireDefault(require("UIComponents/page/UIListingPage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBreadcrumbs = _interopRequireDefault(require("UIComponents/nav/UIBreadcrumbs"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _colors = require("HubStyleTokens/colors");

var _withReviewsQueryState = _interopRequireDefault(require("../../components/detail/reviews/withReviewsQueryState"));

var _ReviewsList = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewsList"));

var _ReviewsListStats = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewsListStats"));

var _AllReviewsReviewRenderer = _interopRequireDefault(require("../../components/detail/reviews/AllReviewsReviewRenderer"));

var _ReviewWizard = _interopRequireDefault(require("../../components/detail/reviews/ReviewWizard"));

var _WriteReviewButton = _interopRequireDefault(require("../../components/detail/reviews/WriteReviewButton"));

var _ReviewsListEmptyState = _interopRequireDefault(require("../../components/detail/reviews/ReviewsListEmptyState"));

var _MainSection = require("../../components/layout/MainSection");

var _MainSectionInner = _interopRequireDefault(require("../../components/layout/MainSectionInner"));

var _Header = _interopRequireDefault(require("../../components/detail/Header"));

var _LoadingWrapper = _interopRequireDefault(require("ecosystem-marketplace-core/components/LoadingWrapper"));

var _usageTracker = require("../../utils/usageTracker");

var _userAgent = require("ecosystem-marketplace-core/utils/userAgent");

var _details = require("../../selectors/details");

var _reviews = require("../../selectors/reviews");

var _requestStates = require("../../selectors/requestStates");

var _auth = require("../../selectors/auth");

var _requestState = require("../../utils/requestState");

var _ReviewsActions = require("../../actions/ReviewsActions");

var _reactRouterDom = require("react-router-dom");

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var EmptyLoadingComponent = function EmptyLoadingComponent() {
  return _react.default.createElement("div", null);
};

var AllReviewsPage = function AllReviewsPage(_ref) {
  var onSortChange = _ref.onSortChange,
      onFilterChange = _ref.onFilterChange,
      onPageChange = _ref.onPageChange,
      queryState = _ref.queryState;

  var _useParams = (0, _reactRouterDom.useParams)(),
      superCategory = _useParams.superCategory,
      category = _useParams.category,
      slug = _useParams.slug;

  var dispatch = (0, _reactRedux.useDispatch)();
  var getListingView = (0, _details.makeGetListingView)();
  var isCustomer = (0, _reactRedux.useSelector)(_auth.getIsCustomer);
  var isPrerenderUserAgent = (0, _userAgent.getIsPrerenderUserAgent)();
  var listingView = (0, _reactRedux.useSelector)(function (state) {
    return getListingView(state, {
      slug: slug
    });
  });
  var reviews = (0, _reactRedux.useSelector)(_reviews.getReviews);
  var reviewsFetchStatus = (0, _reactRedux.useSelector)(_requestStates.getReviewsFetchRequestState);
  var reviewStats = (0, _reactRedux.useSelector)(_reviews.getReviewStats);
  var reviewStatsFetchStatus = (0, _reactRedux.useSelector)(_requestStates.getReviewStatsRequestState);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      wizardOpen = _useState2[0],
      setWizardOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      pageViewTracked = _useState4[0],
      setPageViewTracked = _useState4[1];

  var tracker = (0, _usageTracker.getUsageTracker)();
  var reviewsCount = reviewStats.get('count');
  var name = listingView.name,
      iconUrl = listingView.iconUrl,
      id = listingView.id,
      certifiedAt = listingView.offering.certifiedAt,
      tagline = listingView.tagline,
      reviewability = listingView.reviewability;
  var isPieSyncConnector = listingView.getIsPieSyncConnector();
  var offeringId = listingView.get('offeringId');
  var eventProperties = (0, _react.useMemo)(function () {
    return (0, _extends2.default)({}, listingView.getEventProperties(), {
      screen: 'all reviews'
    });
  }, [listingView]);
  var trackInteraction = (0, _react.useCallback)(function (action, section, value) {
    var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    tracker.track('listing-detail-interaction', (0, _extends2.default)({
      action: action,
      section: section,
      value: value
    }, properties, eventProperties));
  }, [tracker, eventProperties]);
  var documentTitle = (0, _react.useMemo)(function () {
    if (isPieSyncConnector) {
      return (0, _unescapedText.default)('appMarketplace.pieSyncConnector.htmlTitle', {
        name: name
      });
    }

    return (0, _unescapedText.default)('appMarketplace.detail.reviews.all.htmlTitle', {
      name: name
    });
  }, [isPieSyncConnector, name]);
  (0, _react.useEffect)(function () {
    document.title = documentTitle;

    if (!pageViewTracked) {
      tracker.track('all-reviews-pageview', (0, _extends2.default)({}, eventProperties));
      setPageViewTracked(true);
    }
  }, [documentTitle, eventProperties, pageViewTracked, tracker]);
  var renderedHeader = (0, _react.useMemo)(function () {
    var breadcrumbs = _react.default.createElement(_UIBreadcrumbs.default, {
      className: "m-bottom-1 m-top-0 p-left-0"
    }, _react.default.createElement(_UIRouterLink.default, {
      to: "/" + superCategory + "/" + category + "/" + slug + "#reviews"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.detail.reviews.all.back",
      options: {
        name: name
      }
    })));

    return _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(_Header.default, {
      appId: id,
      appName: name,
      breadcrumbs: breadcrumbs,
      certifiedAt: certifiedAt,
      headingLevel: "h2",
      iconUrl: iconUrl,
      isCustomer: isCustomer,
      isPieSyncConnector: isPieSyncConnector,
      showTabs: false,
      showConnectButton: false,
      showSetUpUrl: false,
      tagline: tagline,
      wrapperStyle: {
        paddingBottom: '24px'
      }
    }));
  }, [certifiedAt, name, iconUrl, id, isPieSyncConnector, isCustomer, tagline, superCategory, category, slug]);
  var renderedReviewsListStats = (0, _react.useMemo)(function () {
    if (reviewsCount && offeringId) {
      return _react.default.createElement("div", {
        style: {
          width: 900
        }
      }, _react.default.createElement(_UIFlex.default, {
        align: "center",
        justify: "between"
      }, _react.default.createElement(_H.default, {
        className: "m-top-10 m-bottom-8 is--heading-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "appMarketplace.detail.reviews.all.headingText",
        options: {
          name: name
        }
      })), _react.default.createElement(_WriteReviewButton.default, {
        offeringId: offeringId,
        onClick: function onClick() {
          return setWizardOpen(true);
        },
        reviewability: reviewability,
        size: "md"
      })), _react.default.createElement(_ReviewsListStats.default, {
        className: "m-bottom-15",
        inline: true,
        reviewStats: reviewStats,
        onFilterChange: onFilterChange
      }));
    } else {
      return _react.default.createElement("div", null);
    }
  }, [reviewsCount, offeringId, name, reviewability, reviewStats, onFilterChange]);
  var renderedReviewsListBody = (0, _react.useMemo)(function () {
    if (reviewsCount) {
      return _react.default.createElement(_ReviewsList.default, {
        maxWidth: 900,
        onSortChange: onSortChange,
        onFilterChange: onFilterChange,
        onPageChange: onPageChange,
        queryState: queryState,
        ReviewRenderer: _AllReviewsReviewRenderer.default,
        reviews: reviews,
        reviewStats: reviewStats,
        showPagination: !isPrerenderUserAgent
      });
    } else {
      return _react.default.createElement("div", {
        className: "m-top-15"
      }, _react.default.createElement(_ReviewsListEmptyState.default, {
        offeringId: offeringId,
        reviewability: reviewability,
        onWriteReviewClick: function onWriteReviewClick() {
          return setWizardOpen(true);
        }
      }));
    }
  }, [isPrerenderUserAgent, reviewsCount, offeringId, onSortChange, onFilterChange, onPageChange, queryState, reviews, reviewStats, reviewability]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_PrerenderReady.default, {
    ready: (0, _requestState.isSucceeded)(reviewsFetchStatus)
  }))), _react.default.createElement(_UIListingPage.default, {
    contentAreaFlush: true,
    headerComponent: renderedHeader,
    mainSectionBackgroundColor: _colors.OLAF,
    pageBackgroundColor: _colors.GYPSUM
  }, _react.default.createElement(_MainSection.DetailMainSection, null, _react.default.createElement(_UIFlex.default, {
    direction: "column",
    align: "center",
    alignSelf: "center",
    className: "p-bottom-15"
  }, _react.default.createElement(_LoadingWrapper.default, {
    LoadingComponent: EmptyLoadingComponent,
    requestStatus: reviewStatsFetchStatus
  }, renderedReviewsListStats), _react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, _react.default.createElement(_LoadingWrapper.default, {
    LoadingComponent: EmptyLoadingComponent,
    requestStatus: [reviewsFetchStatus, reviewStatsFetchStatus],
    showOverlay: true
  }, renderedReviewsListBody)))), wizardOpen && _react.default.createElement(_ReviewWizard.default, {
    appName: name,
    appIcon: iconUrl,
    offeringId: offeringId,
    onClose: function onClose() {
      return setWizardOpen(false);
    },
    onSuccess: function onSuccess() {
      setWizardOpen(false);
      dispatch((0, _ReviewsActions.resetReviewsFetch)());
      dispatch((0, _ReviewsActions.resetReviewsStatsFetch)());
    },
    onTrackInteraction: trackInteraction,
    reviewability: reviewability
  })));
};

AllReviewsPage.propTypes = {
  onSortChange: _propTypes.default.func.isRequired,
  onFilterChange: _propTypes.default.func.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  queryState: _propTypes.default.instanceOf(_immutable.default.Map).isRequired
};

var _default = (0, _withReviewsQueryState.default)(AllReviewsPage);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/detail/AllReviewsPage.js
// module id = 906
// module chunks = 209 210 211 212